"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeUserNameModule = void 0;
var referral_game_api_1 = require("../../../api/referral-game-api");
var object_service_1 = require("../../../object-service");
var referral_game_helper_service_1 = require("../services/referral-game-helper.service");
var ChangeUserNameModule = /** @class */ (function () {
    function ChangeUserNameModule() {
        this.referralGame = object_service_1.ObjectService.getInstance(referral_game_api_1.ReferralGameAPI);
        this.vanillaGenerator = object_service_1.ObjectService.getInstance(referral_game_helper_service_1.VanillaGenerator);
        //  private validation = { firstName: {regex:}, lastName: {regex:}, phonePrivate: {regex:}, email: {regex:}}
        this.authentication = {};
    }
    ChangeUserNameModule.prototype.loadModule = function (module, settings) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.settings = settings;
                this.getFields();
                return [2 /*return*/];
            });
        });
    };
    ChangeUserNameModule.prototype.getFields = function () {
        return __awaiter(this, void 0, void 0, function () {
            var actionButton, formFields;
            var _this = this;
            return __generator(this, function (_a) {
                actionButton = document.querySelector('[data-action="submit"]');
                if (actionButton) {
                    actionButton.addEventListener('click', function (event) {
                        _this.tryChangeUsername(event);
                    });
                }
                else {
                    console.error('SUBMIT BUTTON IS REQUIRED [data-action="submit"]');
                }
                formFields = document.querySelectorAll('[data-set]');
                if (formFields.length) {
                    formFields.forEach(function (formField) {
                        formField.addEventListener('keyup', function () {
                            if (formField.value.length > 1) {
                                _this.authentication[formField.getAttribute('data-set')] = formField.value;
                            }
                        });
                        formField.addEventListener('change', function () {
                            if (formField.value.length > 1) {
                                _this.authentication[formField.getAttribute('data-set')] = formField.value;
                            }
                        });
                    });
                }
                else {
                    console.error('NO FORMFIELDS ARE DEFINED');
                }
                return [2 /*return*/];
            });
        });
    };
    ChangeUserNameModule.prototype.tryChangeUsername = function (event) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var formFields, hasEnoughValues, month, day, response;
            var _this = this;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        formFields = document.querySelectorAll('[data-set]');
                        formFields.forEach(function (formField) {
                            if (formField.value.length > 0) {
                                _this.authentication[formField.getAttribute('data-set')] = formField.value.trim();
                            }
                        });
                        hasEnoughValues = Object.values(this.authentication)
                            .filter(function (value) { return value.length > 1; })
                            .length >= 6;
                        if (!hasEnoughValues) return [3 /*break*/, 2];
                        if (((_a = this.authentication.yearOfBirth) === null || _a === void 0 ? void 0 : _a.length) && ((_b = this.authentication.monthOfBirth) === null || _b === void 0 ? void 0 : _b.length) && ((_c = this.authentication.dayOfBirth) === null || _c === void 0 ? void 0 : _c.length)) {
                            month = (+this.authentication.monthOfBirth < 10) ? 0 + this.authentication.monthOfBirth : this.authentication.monthOfBirth;
                            day = (+this.authentication.dayOfBirth < 10) ? 0 + this.authentication.dayOfBirth : this.authentication.dayOfBirth;
                            this.authentication.dateOfBirth = this.authentication.yearOfBirth + '-' + month + '-' + day;
                        }
                        console.log('AUTHENTICATE', this.authentication);
                        this.vanillaGenerator.createLoadingScreen();
                        return [4 /*yield*/, this.referralGame.changeUsername(this.settings.gameId, this.authentication)];
                    case 1:
                        response = _e.sent();
                        console.log('RESPONSE', response);
                        this.vanillaGenerator.deleteLoadingScreen();
                        if (!response) {
                            this.vanillaGenerator.showErrorMessage('No customer with this data found');
                        }
                        else {
                            if ((_d = response === null || response === void 0 ? void 0 : response.error) === null || _d === void 0 ? void 0 : _d.length) {
                                this.vanillaGenerator.showErrorMessage(response === null || response === void 0 ? void 0 : response.error);
                            }
                            else {
                                console.error('SUCCESS SENDING FORM');
                                document.querySelector('[data-ref="submit-webflow"]').click();
                                return [2 /*return*/];
                            }
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.vanillaGenerator.showErrorMessage('Some required parameter is missing!');
                        _e.label = 3;
                    case 3:
                        console.error('ERROR SENDING FORM');
                        return [2 /*return*/];
                }
            });
        });
    };
    return ChangeUserNameModule;
}());
exports.ChangeUserNameModule = ChangeUserNameModule;
